import axios from "axios";
import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Swal from "sweetalert2";
import { baseUrl, userName, ipAddress } from './Univ.js';

function AddStreet() {
  const [booths, setBooths] = useState([]);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [streetData, setStreetData] = useState({
    booth: "",
    name: "",
    total_houses: "",
    status: 1,
  });

  /* ---------------- HANDLE CHANGE ---------------- */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setStreetData({
      ...streetData,
      [name]:
        name === "booth" || name === "total_houses" || name === "status"
          ? Number(value)
          : value,
    });
  };

  /* ---------------- SUBMIT ---------------- */
  const formSubmit = () => {
  // Validation
  if (!streetData.booth || !streetData.name) {
    Swal.fire('Error', 'Please fill all required fields', 'error');
    return;
  }

  // Create FormData
  const _formData = new FormData();
  _formData.append('booth', streetData.booth);
  _formData.append('name', streetData.name);
  _formData.append('total_houses', streetData.total_houses);
  _formData.append('status', '1');
  _formData.append('addedby', userName);
  _formData.append('ip_add', ipAddress);

  // POST request
  axios.post(baseUrl + 'streets/', _formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  })
  .then(response => {
    if (response.status === 200 || response.status === 201) {
      Swal.fire({
        title: 'Street has been added',
        icon: 'success',
        timer: 3000,
        showConfirmButton: false
      });
      setTimeout(() => window.location.reload(), 1000);
      // Reset form
      setStreetData({
        booth: '',
        name: '',
        total_houses: '',
        status: 1,
        addedby: userName,
        ip_add: ipAddress
      });
    }
  })
  .catch(error => {
    console.error(error.response?.data || error);
    Swal.fire('Error', 'Failed to add street', 'error');
  });
};

  /* ---------------- FETCH STREETS ---------------- */
  const fetchStreets = () => {
    setIsLoading(true);
    axios
      .get(baseUrl + "streets/")
      .then((res) => {
        setRows(res.data);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  };

  /* ---------------- FETCH BOOTHS ---------------- */
  const fetchBooths = () => {
    axios
      .get(baseUrl + "booths/")
      .then((res) => setBooths(res.data))
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchBooths();
    fetchStreets();
  }, []);

  /* ---------------- DELETE ---------------- */
  const handleDelete = (id) => {
    Swal.fire({
      title: "Confirm",
      text: "Delete this street?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(baseUrl + "delete-streets/" + id + "/").then(() => {
          Swal.fire("Deleted", "Street removed", "success");
          fetchStreets();
        });
      }
    });
  };

  /* ---------------- DATAGRID COLUMNS ---------------- */
  const columns = [
    { field: "id", headerName: "ID", width: 80 },

    {
      field: "constituency",
      headerName: "Constituency",
      width: 200,
      renderCell: (params) =>
        params?.row?.booth?.constituency?.name || "—",
    },

    {
      field: "booth",
      headerName: "Booth No",
      width: 120,
      renderCell: (params) =>
        params?.row?.booth?.booth_number || "—",
    },

    { field: "name", headerName: "Street Name", width: 200 },

    {
      field: "total_houses",
      headerName: "Houses",
      width: 120,
    },

    {
      field: "status",
      headerName: "Status",
      width: 100,
      renderCell: (params) =>
        params.value === 1 ? "Active" : "Inactive",
    },

    { field: "addedby", headerName: "Created At", width: 180 },

    {
      field: "actions",
      headerName: "Actions",
      width: 120,
      renderCell: (params) => (
        <button
          className="btn btn-danger btn-sm"
          onClick={() => handleDelete(params.row.id)}
        >
          Delete
        </button>
      ),
    },
  ];

  return (
    <section className="container mt-4">
      <div className="card">
        <h4 className="card-header">Add Street</h4>
        <div className="card-body">
          <div className="mb-3">
            <label className="form-label">Booth</label>
            <select
              className="form-control"
              name="booth"
              value={streetData.booth}
              onChange={handleChange}
            >
              <option value="">-- Select Booth --</option>
              {booths.map((b) => (
                <option key={b.id} value={b.id}>
                  Booth {b.booth_number}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">Street Name</label>
            <input
              type="text"
              name="name"
              value={streetData.name}
              onChange={handleChange}
              className="form-control"
              placeholder="Eg: Gandhi Nagar 3rd Street"
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Total Houses</label>
            <input
              type="number"
              name="total_houses"
              value={streetData.total_houses}
              onChange={handleChange}
              className="form-control"
            />
          </div>

          <button className="btn btn-primary" onClick={formSubmit}>
            Save Street
          </button>
        </div>
      </div>

      <div className="mt-4">
        <DataGrid
          rows={rows}
          columns={columns}
          loading={isLoading}
          pageSize={25}
          rowsPerPageOptions={[25, 50, 100]}
          components={{ Toolbar: GridToolbar }}
          autoHeight
          sx={{
            boxShadow: 4,
            border: 4,
            borderColor: 'primary.light',
            '& .MuiDataGrid-cell:hover': {
              color: 'primary.main'
            }
          }}

        />
      </div>
    </section>
  );
}

export default AddStreet;
